// What a page load turns into, decided once before anything renders:
//   "guest"       - a scanned QR code (?qr_table= / ?qr_room=). Guests use
//                   their own phones, however old, so this never depends on
//                   the browser check and loads only the plain stylesheet.
//   "unsupported" - staff on a browser the interface cannot draw (Tailwind v4
//                   needs Chrome 111 / Safari 16.4 / Firefox 128): a notice
//                   to update instead of a broken screen.
//   "app"         - everything else.
export function bootMode({ search, canUseNextUi }) {
  const params = new URLSearchParams(search);
  if (params.has("qr_table") || params.has("qr_room")) return "guest";
  return canUseNextUi ? "app" : "unsupported";
}
